import React, {
  createContext,
  useState,
  useContext,
  useMemo,
  ReactNode,
} from 'react'

import { ThreeDAuthBox } from 'containers/Checkout/styled'

interface ThreeDSecureContextType {
  showThreeDAuth: boolean
  updateThreeDAuth: (showThreeDAuthValue: boolean) => void
  threeDAuthContainerId: string
}

export const ThreeDSecureContext =
  createContext<ThreeDSecureContextType | null>(null)

interface ThreeDSecureProviderProps {
  children: ReactNode
  containerId?: string
}

export const ThreeDSecureProvider: React.FC<ThreeDSecureProviderProps> = ({
  children,
  containerId = 'checkout-3d-auth-container',
}) => {
  const [showThreeDAuth, setShowThreeDAuth] = useState(false)

  const updateThreeDAuth = (showThreeDAuthValue: boolean) => {
    setShowThreeDAuth(showThreeDAuthValue)
  }

  const value = useMemo(
    () => ({
      showThreeDAuth,
      updateThreeDAuth,
      threeDAuthContainerId: containerId,
    }),
    [showThreeDAuth, containerId],
  )

  return (
    <ThreeDSecureContext.Provider value={value}>
      {children}
      <div className="tw-flex tw-justify-center tw-w-full">
        <ThreeDAuthBox id={containerId} showThreeDAuth={showThreeDAuth} />
      </div>
    </ThreeDSecureContext.Provider>
  )
}

export const useThreeDSecure = (): ThreeDSecureContextType => {
  const context = useContext(ThreeDSecureContext)
  if (!context) {
    throw new Error(
      'useThreeDSecure must be used within a ThreeDSecureProvider',
    )
  }
  return context
}

export { ThreeDAuthBox }
